<template>
  <v-container grid-list-md>
    <v-card>
      <v-card-title> <strong>Flip</strong> </v-card-title>
      <v-card-text>
        <v-divider class="mb-2"></v-divider>

        <v-layout wrap>
          <v-flex xs12 md3>
            <v-menu v-model="mnuDtInicio" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dtInicio"
                  autofocus
                  label="Período"
                  prepend-icon="event"
                  v-on="on"
                  color="blue-grey lighten-2"
                  @click:clear="dtInicioUS = ['', '']"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker v-model="dtInicioUS" locale="pt-br" no-title range style="background-color: #ddd"
                ><v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="
                    mnuDtInicio = false;
                    limpaFiltro();
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 md1>
            <v-autocomplete
              v-if="$store.state.site.publicacaoLegal"
              :disabled="(!$store.state.usuario.idCliente && !$store.state.site.flipPublico) || ($route.params && $route.params.produto)"
              v-model="filtroPL"
              :filter="filtrarObjetos"
              :items="itensPL"
              label="Public. Legal"
              item-text="nome"
              item-value="id"
              @change="limpaFiltro"
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 md2>
            <v-text-field
              v-if="$store.state.site.publicacaoLegal && filtroPL != 0"
              background-color="white"
              v-model="filtroCNPJ"
              append-icon="search"
              label="Pesquisar CNPJ..."
              v-mask="'##############'"
              placeholder="Pesquisa pelo CNPJ"
              hide-details
              @keyup.enter="limpaFiltro"
              @click:append="limpaFiltro"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md3>
            <v-text-field
              :disabled="$route.params && $route.params.produto"
              background-color="white"
              v-model="filtroEdicao"
              append-icon="search"
              label="Pesquisar nome edição..."
              placeholder="Pesquisa pelo nome da edição"
              hide-details
              @keyup.enter="limpaFiltro"
              @click:append="limpaFiltro"
              @change="filtroEdicao = filtroEdicao.toUpperCase()"
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 md3>
            <v-text-field
              background-color="white"
              v-model="filtroTexto"
              append-icon="search"
              label="Pesquisar texto nas edições..."
              placeholder="Pesquisa pelo texto nas edições"
              hide-details
              @keyup.enter="limpaFiltro"
              @click:append="limpaFiltro"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-divider class="mb-4"></v-divider>
        <v-progress-linear :active="carregando" class="ma-0" color="cyan accent-3" height="3" indeterminate></v-progress-linear>

        <v-data-iterator :items="registros" :items-per-page="12" hide-default-footer :no-data-text="mensagemPesquisa" class="text-center">
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.name" cols="12" sm="4" md="3" lg="2">
                <v-card class="mx-auto text-left block block-rounded block-link-pop suita-block-home" max-width="220" min-height="290">
                  <v-layout>
                    <v-flex xs1 class="mt-12 pt-4 ml-2">
                      <router-link :to="'/flip/edicao/' + item._id" target="_blank" style="text-decoration: none" v-if="direitoEditar">
                        <v-icon color="blue" title="Editar">edit</v-icon>
                      </router-link>
                      <v-spacer></v-spacer>
                      <v-icon color="blue lighten-2" title="Visualizar Flip" @click="visualizarFlip(item, 0)">flip</v-icon>
                      <v-spacer></v-spacer>
                      <v-btn class="mt-2" fab x-small max-height="24" max-width="24" title="Visualizar PDF" @click="visualizarPDF(item)">pdf</v-btn>
                      <v-spacer></v-spacer>
                      <v-icon v-if="item.assinada" class="mt-2" color="green lighten-2" title="Assinada">verified_user</v-icon>
                    </v-flex>
                    <v-flex xs10>
                      <div class="text-center">
                        <a target="_blank" class="estilo-link-site" @click="visualizarFlip(item, 0)">
                          <img class="img-responsive" style="width: 100%" max-height="196" v-bind:src="item.capa" title="Abrir" />
                        </a>
                      </div>
                    </v-flex>
                  </v-layout>

                  <v-card-title class="mt-n4">
                    <h5>{{ item.edicaoNome }}</h5>
                  </v-card-title>

                  <v-card-subtitle>
                    Edição Nº {{ item.edicaoNumero }}<br />
                    Data Edição: {{ formatDate(item.edicaoDataEntrada) }}<br />
                    <span v-if="item.publicacaoLegal && item.cnpj" style="font-size: 12px">
                      CNPJ:
                      {{ formatCNPJ(item.cnpj) }}
                    </span>

                    <v-divider v-if="item.paginasBusca.length"></v-divider>

                    <div v-if="item.paginasBusca.length">
                      <v-data-iterator :items="item.paginasBusca" :items-per-page="24" hide-default-footer no-data-text>
                        <template v-slot:default="props">
                          <v-row class="mt-2 ml-n4 mb-n8">
                            <div class="col-xs-1" v-for="item in props.items" :key="item.paginasNumero">
                              <a href="#" @click="abrirTexto(item)" color="grey lighten-3" v-if="item.paginasNumero"
                                ><span style="font-size: 12px; margin-left: 4px">{{ item.paginasNumero }}</span></a
                              >
                            </div>
                          </v-row>
                        </template>
                      </v-data-iterator>
                      <br />
                    </div>
                  </v-card-subtitle>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
        <div class="px-6 mt-2">
          <v-layout wrap>
            <v-flex xs12 class="text-xs-center">
              <v-pagination v-model="paginaAtual" :length="totalPaginas" :total-visible="$vuetify.breakpoint.xsOnly ? 5 : 7" circle></v-pagination>
            </v-flex>
          </v-layout>
        </div>

        <span v-if="!$store.state.login"
          >Efetue
          <router-link
            :to="`/login?redirect=newflip${$route.params.produto ? '/' + $route.params.produto : ''}${$route.params.data ? '/' + $route.params.data : ''}${
              $route.params.edicao ? '/' + $route.params.edicao : ''
            }`"
          >
            <a href="#">login</a>
          </router-link>
          para acessar as edições do jornal.</span
        >
        <span v-if="$store.state.login && !$store.state.usuario.onlineCorrente" class="font-italic red--text"
          >Você não possui assinatura ativa.
          <div v-if="$store.state.site.assinante">
            <span class="black--text"> Para verificar suas assinaturas, </span>
            <router-link to="/assinaturas">
              <a href="#">clique aqui</a>
            </router-link>
          </div>
          <div v-if="$store.state.site.paywall">
            <span class="black--text"> Para adquirir uma assinatura, </span>
            <router-link to="/assine">
              <a href="#">clique aqui</a>
            </router-link>
          </div>
        </span>
      </v-card-text>
    </v-card>

    <v-snackbar v-model="snackErro" color="error" :timeout="5000" centered>{{ mensagem }}</v-snackbar>

    <v-dialog v-model="dialogFlip" width="100vw">
      <v-card height="90vh">
        <Flip :urlFlip="urlFlip" :dialogFlip.sync="dialogFlip" />
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTexto" max-width="1000">
      <v-card>
        <v-toolbar color="blue lighten-2">
          <span class="headline">{{ textoTitulo }} </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogTexto = false">
            <v-icon>cancel</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md12>
                <v-textarea v-model="itemTextoFlip.paginasTexto" counter rows="10" color="blue-grey lighten-2"></v-textarea>
              </v-flex>
              <v-flex xs12 md12 class="text-right">
                <v-btn small @click="visualizarFlip(itemTextoFlip, itemTextoFlip.paginasNumero)">Abrir Página</v-btn>
                <v-btn small class="ml-2" @click="dialogTexto = false">Fechar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Flip from "./Flip.vue";
import util from "../util.js";
import { api } from "@/services/api.js";
import download from "downloadjs";
export default {
  components: {
    Flip
  },
  data() {
    return {
      direitoCriar: false,
      direitoEditar: false,
      direitoExcluir: false,

      dtInicioUS: ["", ""],
      mnuDtInicio: false,
      filtroPL: null,
      filtroCNPJ: "",
      filtroEdicao: "",
      filtroTexto: "",

      itensPL: [
        { id: null, nome: "" },
        { id: 1, nome: "Somente" },
        { id: 0, nome: "Exceto" }
      ],

      dialogFlip: false,
      urlFlip: "",

      dialogTexto: false,
      textoTitulo: "",
      itemTextoFlip: {},

      snackErro: false,
      mensagem: "",

      paginaAtual: 1,
      registrosPagina: 12,
      totalRegistros: 0,
      totalPaginas: 0,

      mensagemPesquisa: "",
      registros: [],
      carregando: true
    };
  },
  methods: {
    limpaFiltro() {
      this.paginaAtual = 1;
      this.pesquisaDados();
    },
    async pesquisaDados() {
      this.registros = [];
      this.mensagemPesquisa = "";
      if (this.$route.params.produto) {
        if (this.$route.params.produto == "PUBLICACAO_LEGAL") {
          this.filtroPL = 1;
          if (this.$route.params.data) {
            this.dtInicioUS = [this.$route.params.data, this.$route.params.data];
            this.filtroEdicao = this.$route.params.edicao;
          }
        } else {
          this.filtroPL = 0;
          this.filtroEdicao = this.$route.params.produto;
        }
      }

      var inic = "";
      var fim = "";
      if (this.dtInicioUS && this.dtInicioUS.length > 1) {
        inic = this.dtInicioUS[0];
        fim = this.dtInicioUS[1];
      }
      if (!inic || !fim) {
        this.mensagem = "Verifique o período";
        this.snackErro = true;
        return;
      }
      var dtInic = util.parseDateUS(this.dtInicioUS[0]);
      var dtFim = util.parseDateUS(this.dtInicioUS[1]);
      if (dtInic > dtFim) {
        this.mensagem = "Data inicial não pode ser superior a data final";
        this.snackErro = true;
        return;
      }

      //sinaliza que está carregando
      this.carregando = true;

      try {
        //faz a pesquisa no banco de dados
        const response = await api.get(
          "/flip/carregaedicoes?idSite=" +
            this.$store.state.site.id +
            "&idEdicao=" +
            "&dataInicioPesq=" +
            inic +
            "&dataFimPesq=" +
            fim +
            "&edicaoNome=" +
            this.filtroEdicao +
            "&textoPesquisa=" +
            this.filtroTexto +
            (this.filtroPL != null ? "&publicacaoLegal=" + this.filtroPL : "") +
            (this.filtroPL != 0 && this.filtroCNPJ ? "&cnpj=" + this.filtroCNPJ : "") +
            "&pagina=" +
            this.paginaAtual
        );

        //seta as variaveis com o retorno
        response.data.data.forEach((registro) => {
          var urlApi = (window.location.host.includes("localhost") ? "http://localhost:3000" : "") + "/api/";

          registro.capa = `${urlApi}arquivos/${this.$store.state.site.id}/flip/${registro.edicaoData}/${registro.edicaoNomePasta}/jpg/${
            registro.Paginas[0].paginasNumero
          }.jpeg?${new Date().getTime()}`;

          registro.edicaoPaginasBusca.sort(function (a, b) {
            if (a > b) {
              return 1;
            }
            if (a < b) {
              return -1;
            }
            return 0;
          });

          registro.paginasBusca = [];
          registro.edicaoPaginasBusca.forEach((busca) => {
            registro.Paginas.forEach((pagina) => {
              if (pagina.paginasNumero == busca) {
                registro.paginasBusca.push({
                  edicaoNome: registro.edicaoNome,
                  edicaoNumero: registro.edicaoNumero,
                  edicaoData: registro.edicaoData,
                  paginasNumero: pagina.paginasNumero,
                  paginasTexto: pagina.paginasTexto,
                  edicaoNomePasta: registro.edicaoNomePasta
                });
              }
            });
          });

          this.registros.push(registro);
        });

        this.totalRegistros = response.data.total;

        this.totalPaginas = Math.ceil(this.totalRegistros / this.registrosPagina);

        this.dtInicioUS = [response.data.dtInicio, response.data.dtFim];

        //fecha o loading
        this.carregando = false;
        //se não achar registro seta a mensagem senão deixa em branco
        this.mensagemPesquisa = this.registros.length > 1 ? "" : "Nenhum registro encontrado";
      } catch (e) {
        this.carregando = false;
        if (e.toString().includes("status code 400")) {
          this.$router.push(this.$route.path);
          this.$router.go(this.$route.path);
          this.mensagemPesquisa = "SESSÃO EXPIRADA";
        } else {
          this.mensagemPesquisa = "Erro ao buscar dados: " + e;
        }
      }
    },

    visualizarPDF(item) {
      var caminhoPDF = `/${this.$store.state.site.id}/flip/${item.edicaoData}/${item.edicaoNomePasta}/${item.edicaoNomePasta}-${item.edicaoData}.pdf`;
      var urlApi = (window.location.host.includes("localhost") ? "http://localhost:3000" : "") + "/api/";

      download(urlApi + "fin/arquivo/pdf?caminho=" + caminhoPDF);
    },
    visualizarFlip(item, pagina) {
      this.urlFlip = `/${this.$store.state.site.id}/flip/${item.edicaoData}/${item.edicaoNomePasta}${pagina ? "&pagina=" + pagina : "&paginas=" + item.Paginas.length}`;
      this.dialogFlip = true;
    },
    closeFlip() {
      this.dialogFlip = false;
      this.urlFlip = "";
    },
    abrirTexto(item) {
      this.itemTextoFlip = item;
      this.textoTitulo = `Texto encontrado na página ${item.paginasNumero} da edição '${item.edicaoNome}' número '${item.edicaoNumero}' de '${item.edicaoData}'`;
      this.dialogTexto = true;
    },

    filtrarObjetos(item, queryText, itemText) {
      return util.filtrarObjetos(item, queryText, itemText);
    },
    formatDate(date) {
      return util.formatDate(date);
    },
    formatDateTime(datetime) {
      return util.formatDateTime(datetime);
    },
    formatCNPJ(cnpj) {
      return util.formatIdentificacao(cnpj);
    }
  },
  computed: {
    dtInicio() {
      var retorno = "";
      if (this.dtInicioUS && this.dtInicioUS.length > 1) {
        var dtInic = util.parseDateUS(this.dtInicioUS[0]);
        var dtFim = util.parseDateUS(this.dtInicioUS[1]);
        if (dtInic > dtFim) {
          retorno = "";
        } else {
          retorno = util.formatDate(this.dtInicioUS[0]) + " - " + util.formatDate(this.dtInicioUS[1]);
        }
      }
      return retorno;
    }
  },

  watch: {
    paginaAtual() {
      this.pesquisaDados();
    }
  },

  async created() {
    var dtDia1 = new Date();
    dtDia1.setDate(1);

    var dtDia31 = new Date();
    dtDia31.setMonth(dtDia31.getMonth() + 1);
    dtDia31.setDate(1);
    dtDia31.setDate(dtDia31.getDate() - 1);

    this.dtInicioUS = [util.dateToStringUS(dtDia1), util.dateToStringUS(dtDia31)];

    do {
      await util.delay(1000);
    } while (!this.$store.state.site.enderecoSite);

    await util.delay(3000);

    if (!this.$store.state.site.flip) {
      //* Se jornal não possui flip, redireciona
      this.mensagem = "Ainda não constam edições impressas aqui. Redirecionando...";
      this.snackErro = true;
      setTimeout(() => {
        this.$router.push(`/assine`);
      }, 4000);
    } else if (!this.$store.state.usuario.idCliente && !this.$store.state.site.flipPublico && !this.$store.state.site.publicacaoLegal) {
      //* Se usuário não está autenticado e jornal não possui publicações legais, envia para o login
      this.filtroPL = 1;
      this.mensagem = "Não constam publicações legais aqui. Efetue login para visualizar as demais edições. Redirecionando...";
      this.snackErro = true;
      setTimeout(() => {
        this.$router.push(
          `/login?redirect=/newflip${this.$route.params.produto ? "/" + this.$route.params.produto : ""}${this.$route.params.data ? "/" + this.$route.params.data : ""}${
            this.$route.params.edicao ? "/" + this.$route.params.edicao : ""
          }`
        );
      }, 6000);
    } else {
      document.title = this.$store.state.site.nome;
      if (!this.$store.state.usuario.idCliente && !this.$store.state.site.flipPublico) {
        this.filtroPL = 1;
      }
      this.pesquisaDados();
    }
  }
};
</script>

<style>
.block.block-rounded > .block-content:first-child {
  border-top-left-radius: 0.4rem;
  border-top-right-radius: 0.4rem;
}
.block-content.block-content-full {
  padding-bottom: 1.45rem;
}
.suita-block-home:hover {
  box-shadow: 0 0.5rem 2rem #e1e1e1;
}
.suita-block-home:hover {
  box-shadow: 0 0.5rem 2.5rem #e6e6e6;
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
  opacity: 1;
}
.suita-block-home {
  display: block;
  color: #575757;
  font-weight: 400;
  transition: opacity 0.15s ease-out, box-shadow 0.15s ease-out, -webkit-transform 0.15s ease-out;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out, box-shadow 0.15s ease-out;
  transition: transform 0.15s ease-out, opacity 0.15s ease-out, box-shadow 0.15s ease-out, -webkit-transform 0.15s ease-out;
}
.suita-block-home button {
  font-size: 12px;
  font-weight: 500;
}
</style>
